import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { Icon, SportFilterHeading } from 'components';
import globalMessages from 'messages';
import useFeaturedTournamentsHeading from './useFeaturedTournamentsHeading';

import featuredTournamentIcon from 'assets/svg/top-tournament.svg';
import './featuredTournamentsHeading.scss';

const FeaturedTournamentsHeading: React.FC = () => {
    const { isActive, count, openOverlay } = useFeaturedTournamentsHeading();
    const { formatMessage } = useIntl();

    if (count === 0) return null;

    return (
        <Link to={{ search: '' }}>
            <SportFilterHeading
                title={formatMessage(globalMessages.featured)}
                logo={<Icon styleName="icon" glyph={featuredTournamentIcon} />}
                isActive={isActive}
                onClick={openOverlay}
            />
        </Link>
    );
};

export default React.memo(FeaturedTournamentsHeading);
